import React from 'react'
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete'
import { ReactSession } from 'react-client-session'

class LocationSearchInput extends React.Component {
  constructor(props) {
    super(props)
    this.state = { address: '' }
  }

  //get coordinates of restaurant
  handleChange = (address) => {
    this.setState({ address })
  }

  handleSelect = (address) => {
    ReactSession.setStoreType('localStorage')
    ReactSession.set('address', address)

    geocodeByAddress(address)
      .then((results) => getLatLng(results[0]))
      .then((latLng) => {
        window.onbeforeunload = function () {
          ReactSession.set('coordinates', latLng)
        }
        window.location.reload()
      })
      .catch((error) => console.error('Error', error))
  }

  render() {
    let search_options = {
      // location: new window.google.maps.LatLng(18.466667, -77.916667),
      // radius: 20000,
      componentRestrictions: { country: ['jm'] },
      // types: ["address"],    // address, (cities), (regions) ...
    }
    return (
      <PlacesAutocomplete
        value={this.state.address}
        onChange={this.handleChange}
        onSelect={this.handleSelect}
        searchOptions={search_options}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <div>
            <input
              {...getInputProps({
                placeholder: 'Enter delivery address',
                className: 'location-search-input',
              })}
            />
            <div className="autocomplete-dropdown-container">
              {loading && <div>Loading...</div>}
              {suggestions.map((suggestion, index) => {
                const className = suggestion.active
                  ? 'suggestion-item--active'
                  : 'suggestion-item'
                // inline style for demonstration purpose
                let style = suggestion.active
                  ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                  : { backgroundColor: '#ffffff', cursor: 'pointer' }
                style = {
                  // backgroundColor: "#ddcfcf",
                  position: 'absolute!important',
                  zIndex: 1000,
                  // borderRadius: "2px",
                  // borderTop: "1px solid #d9d9d9",
                  fontFamily: 'Arial, sans-serif',
                  boxShadow: '0 2px 6px rgba(0, 0, 0, 0.3)',
                  boxSizing: 'border-box',
                  overflow: 'hidden',
                }
                return (
                  <div
                    key={index}
                    {...getSuggestionItemProps(suggestion, {
                      className,
                      style,
                    })}
                  >
                    <div
                      className="row"
                      style={{
                        backgroundColor: '#faf8f8',
                        color: 'black',
                        borderRadius: '10px',
                        margin: '4px',
                      }}
                    >
                      <span>{suggestion.description}</span>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        )}
      </PlacesAutocomplete>
    )
  }
}
export default LocationSearchInput
